import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { cn } from "@/lib/utils";
import { Toaster } from "@/components/ui/sonner";
import { OrderListProvider, useOrderList } from "@/context/OrderListContext";
import { trackEvent } from "@/lib/api";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import ProtectedAdminRoute from "@/components/admin/ProtectedAdminRoute";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";
import FloatingOrderButton from "@/components/layout/FloatingOrderButton";
import MobileOrderBar from "@/components/layout/MobileOrderBar";
import OrderListPanel from "@/components/order/OrderListPanel";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Market from "@/pages/Market";
import MarketDetail from "@/pages/MarketDetail";
import ProductDetail from "@/pages/ProductDetail";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Category from "@/pages/Category";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/components/common/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import TrustCenter from "@/pages/TrustCenter";
import Report from "@/pages/Report";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function CustomerShell() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const { count } = useOrderList();
  useEffect(() => {
    try {
      if (!sessionStorage.getItem("ek_visit_sent")) {
        sessionStorage.setItem("ek_visit_sent", "1");
        trackEvent("visit");
      }
    } catch {
      /* ignore */
    }
  }, []);
  return (
    <div className={cn("theme-dark min-h-screen bg-[#120D0A]", count > 0 && "pb-[76px] lg:pb-0")}>
      <Navbar />
      <main className={isHome ? "" : "pt-20 lg:pt-24"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/urunler" element={<Products />} />
          <Route path="/market" element={<Market />} />
          <Route path="/market/:slug" element={<MarketDetail />} />
          <Route path="/urun/:slug" element={<ProductDetail />} />
          <Route path="/paketler" element={<Packages />} />
          <Route path="/paket/:slug" element={<PackageDetail />} />
          <Route path="/kategori/:slug" element={<Category />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/iletisim" element={<Contact />} />
          {/* Sadeleştirme: kaldırılan sayfalar uygun hedeflere yönlendirilir */}
          <Route path="/premium" element={<Navigate to="/urunler" replace />} />
          <Route path="/magaza" element={<Navigate to="/iletisim" replace />} />
          <Route path="/rehber" element={<Navigate to="/" replace />} />
          <Route path="/rehber/:slug" element={<Navigate to="/" replace />} />
          {/* Bilinmeyen URL → gerçek 404 (noindex) */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
      <FloatingOrderButton />
      <MobileOrderBar />
      <OrderListPanel />
    </div>
  );
}

function CustomerApp() {
  return (
    <OrderListProvider>
      <CustomerShell />
    </OrderListProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route
              path="/admin/login"
              element={
                <AdminAuthProvider>
                  <AdminLogin />
                </AdminAuthProvider>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminAuthProvider>
                  <ProtectedAdminRoute>
                    <AdminDashboard />
                  </ProtectedAdminRoute>
                </AdminAuthProvider>
              }
            />
            <Route path="/marka-guven-merkezi" element={<TrustCenter />} />
            <Route path="/rapor/ertan-kasap-marka-donusumu" element={<Report />} />
            <Route path="/*" element={<CustomerApp />} />
          </Routes>
          <Toaster theme="light" position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
